import React from "react";
import classes from "./RadioBtns.module.css";

const RadioInput = ({ name, onChangeValue, value, children, row }) => {

    validateChildrenTree(children);

    return <div className={`${classes.RadioBtn} ${row && classes.Row}`}>
        {children.map(o => <div className={classes.Flex} key={o.props.value}>
            <input type={'radio'} name={name} value={o.props.value} onChange={(e) => onChangeValue(name, e.target.value)} checked={o.props.value == value}></input>
            <label>{o.props.children}</label>
        </div>)}
    </div>


}

const RadioOption = ({ value, children }) => {
    return <></>
}

const validateChildrenTree = (children) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        let error;
        if (children instanceof Array) {
            if (children.some(f => f.type !== RadioOption))
                error = "RadioInput has children that aren't RadioOption component";

        } else {
            if (children.type !== RadioOption)
                error = "RadioInput has children that aren't RadioOption component";
        }
        if (error)
            throw new Error(`${error} note that there are no unnecessary spaces`);
    }
}

export { RadioInput, RadioOption };